import { Rest, baseUrl, keycloakUrl } from '../../../lib/rest'
import * as types from '../../../constants/types'
import * as util from '../components/util'

export const loginUrl = `${baseUrl}/auth/v1/code`
export const keycloakAuthUrl = `${keycloakUrl}/auth/realms/pe/protocol/openid-connect/auth`
export const keycloakLogoutUrl = `${keycloakUrl}/auth/realms/pe/protocol/openid-connect/logout`
export const statusUrl = `${baseUrl}/status`
export const userInfoUrl = `${baseUrl}/userinfo/v1`

export function statusRequest () {
  return dispatch => {
    return Rest.get(statusUrl)
      .then(util.handleErrors)
      .then(res => {
        if (res.status === 200) {
          dispatch(statusReceived(res.statusText))
        }
      })
      .catch(err => {
        return dispatch(util.onServerError(err))
      })
  }
}

export function loginRequest (url) {
  const redirect_uri = encodeURIComponent(url)
  const request = {
    scope: 'openid',
    response_type: 'code',
    client_id: 'surveyqa',
    redirect_uri
  }
  let qs = Rest._buildQueryString(request)
  let authUrl = keycloakAuthUrl + '?' + qs
  window.location.replace(authUrl)
}

export function googleLoginRequest (url) {
  const redirect_uri = encodeURIComponent(url)
  const request = {
    kc_idp_hint: 'google',
    scope: 'openid',
    response_type: 'code',
    client_id: 'surveyqa',
    redirect_uri
  }
  let qs = Rest._buildQueryString(request)
  let authUrl = keycloakAuthUrl + '?' + qs
  window.location.replace(authUrl)
}

export function getSessionRequest (request) {
  return dispatch => {
    return Rest.post(loginUrl, request)
      .then(util.handleErrors)
      .then(res => res.json())
      .then(res => {
        if (res != null && util.hasError(res)) {
          return dispatch(util.showCustomError(res))
        } else {
          return dispatch(userLoggedIn(res))
        }
      })
      .catch(err => {
        return dispatch(util.onServerError(err))
      })
  }
}

export function logoutUser (url) {
  const redirect_uri = encodeURIComponent(url)
  const request = {
    redirect_uri
  }
  let qs = Rest._buildQueryString(request)
  let authUrl = keycloakLogoutUrl + '?' + qs
  window.location.replace(authUrl)
  return dispatch => {
    return dispatch(util.logoutUser())
  }
}

export function loadUserInfo() {
  return dispatch => {    
    return Rest.get(`${userInfoUrl}`)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { userinfo: data }
            dispatch(onFetchUserInfoSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

function userLoggedIn (res) {
  util.storeCurrentUser(res)
  return {
    type: types.AUTH_STATE_SUCCESS
  }
}

function statusReceived (message) {
  return {
    type: types.STATUS_RECEIVED,
    status: message
  }
}

function onFetchUserInfoSuccess(payload) {
  util.storeCurrentEmail(payload)
  return {
    type: "USERINFO_DID_LOAD",
    payload
  }
}